'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const TooltipBox = styled(Box)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '.icon': {
        marginRight: '5px',
        color: theme.palette.secondary.main
    },
}));

export default TooltipBox;
